import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzExpandableText',
  props: {
    description: null,
    maxLine: {
      default: 3
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var expanded = ref(false);
    function toggle() {
      expanded.value = !expanded.value;
    }
    return {
      __sfc: true,
      props: props,
      expanded: expanded,
      toggle: toggle
    };
  }
});